import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyEntitySalesCreditTermsContainerModel } from "../../../../../../models/aggregates/company";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
  providedIn: "root",
})
export class CompanyEntitySalesCreditTermService extends BaseApiTemplateService<CompanyEntitySalesCreditTermsContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "company-entity-sales-credit-terms/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "company-entity-sales-credit-terms/backoffice-ep";
    this.httpClient = http;
  }
}
